var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEterGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2814_28470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3174 60.6249V80C30.026 80 38.8449 71.2499 38.8449 60.6249V41.2498C28.1363 41.2498 19.3174 49.7915 19.3174 60.6249Z",
    fill: "#004B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9448 19.3751V38.7502C51.6535 38.7502 60.4724 30.0002 60.4724 19.3751V0C49.7637 0 40.9448 8.75004 40.9448 19.3751Z",
    fill: "#004B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5276 20.2089H0C0 30.8339 8.8189 39.584 19.5276 39.584H39.0551C39.0551 28.9589 30.2362 20.2089 19.5276 20.2089Z",
    fill: "#004B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4724 60.2088H79.9999C79.9999 49.5838 71.181 40.8337 60.4724 40.8337H40.9448C40.9448 51.6671 49.7637 60.2088 60.4724 60.2088Z",
    fill: "#004B2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2814_28470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEterGreen);
export default __webpack_public_path__ + "static/media/eter-green.25630f6cdc8318efc5b2651f9e0e2de9.svg";
export { ForwardRef as ReactComponent };